// extracted by mini-css-extract-plugin
export default {"wrapper":"NotifBar_wrapper__mhHvH"};